"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LinkedItem = function LinkedItem() {
  _classCallCheck(this, LinkedItem);

  this.next = null;
  this.prev = null;
};

exports["default"] = LinkedItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/utils/linked-item.js
// module id = 214
// module chunks = 0